import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import DataTableAnafLog from "@/components/DataTableAnafLog.vue";
import { onMounted, ref } from "vue";
import axios from "axios";
import store from "@/store";
import dayjs from "dayjs";

type tInvoice = {
  PartitionKey: string;
  RowKey: string;
  name: string;
  invoiceID: string;
  issueDateF: string;
  TimestampF: string;
  anafErr: string;
  anafState: string;
  anafIncarcare: string;
  anafDescarcare: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'TableInvoices',
  setup(__props) {

const invoices = ref<tInvoice[]>([]);
const invoice = ref<tInvoice>();
const showAnafLog = ref(false);

onMounted(() => {
  getInvoices();
});

store.watch(
  (state) => state.invoicesUploaded,
  (uploaded) => {
    if (uploaded) {
      getInvoices();
      store.commit("setInvoicesUploaded", false);
    }
  }
);
function getInvoices() {
  axios
    .get("api/v1/invoices")
    .then((response) => {
      response.data.forEach(
        (invoice: {
          Timestamp: string;
          TimestampF: string;
          issueDate: string;
          issueDateF: string;
        }) => {
          invoice.TimestampF = dayjs(invoice.Timestamp).format(
            "DD/MM/YYYY HH:mm"
          );
          invoice.issueDateF = dayjs(invoice.issueDate).format("DD/MM/YYYY");
        }
      );
      invoices.value = response.data;
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    });
}

function downloadInvoice(invoice: { RowKey: string; name: string }) {
  axios
    .get(`api/v1/invoice/${invoice.RowKey}`, {
      responseType: "blob",
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${invoice.name}`);
      document.body.appendChild(link);
      link.click();
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    });
}
/*
function downloadPDFInvoice(invoice: { RowKey: string; name: string }) {
  axios
    .get(`api/v1/invoicepdf/${invoice.RowKey}`, {
      // responseType: "blob",
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `invoice.pdf`);
      document.body.appendChild(link);
      link.click();
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    });
}
*/
function downloadInvoiceSigned(invoice: { RowKey: string; name: string }) {
  axios
    .get(`api/v1/invoicesigned/${invoice.RowKey}`, {
      responseType: "blob",
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${invoice.name}.zip`);
      document.body.appendChild(link);
      link.click();
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    });
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      label: "Refresh",
      icon: "pi pi-refresh",
      class: "p-button-success p-button-rounded mx-3",
      onClick: getInvoices
    }),
    _createVNode(_component_DataTable, {
      value: invoices.value,
      scrollHeight: `${_unref(store).state.win.h - 140}px`,
      style: _normalizeStyle(`height: ${_unref(store).state.win.h - 140}px; width: ${
      _unref(store).state.win.w - 230
    }px`),
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: "State",
          style: {"max-width":"50px"}
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.anafState == 'nok')
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "pi pi-times",
                  class: "p-button-rounded p-button-danger",
                  style: {"width":"40px","height":"40px"},
                  onClick: ($event: any) => ((showAnafLog.value = true), (invoice.value = slotProps.data))
                }, null, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    
            `Not accepted by ANAF.\n Detailed description in Signed file`
          ,
                    void 0,
                    { bottom: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (slotProps.data.anafState == 'ok')
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  icon: "pi pi-check",
                  class: "p-button-rounded p-button-success",
                  style: {"width":"40px","height":"40px"}
                }, null, 512)), [
                  [
                    _directive_tooltip,
                    `Succesfully confirmed by ANAF`,
                    void 0,
                    { bottom: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "File",
          style: {"max-width":"50px"}
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode(_component_Button, {
              icon: "pi pi-download",
              class: "p-button-rounded p-button-success",
              onClick: ($event: any) => (downloadInvoice(slotProps.data)),
              style: {"width":"40px","height":"40px"}
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                `Download original file`,
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Signed",
          style: {"max-width":"50px"}
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode(_component_Button, {
              icon: "pi pi-download",
              class: "p-button-rounded p-button-success",
              onClick: ($event: any) => (downloadInvoiceSigned(slotProps.data)),
              style: {"width":"40px","height":"40px"}
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                `Download file signed by ANAF`,
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "TimestampF",
          header: "Updated",
          sortable: "",
          sortField: "Timestamp",
          style: {"min-width":"160px"}
        }),
        _createVNode(_component_Column, {
          field: "invoiceID",
          header: "Invoice ID",
          sortable: "",
          style: {"min-width":"100px","max-width":"400px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
        }),
        _createVNode(_component_Column, {
          field: "name",
          header: "File name",
          sortable: "",
          style: {"min-width":"100px","max-width":"400px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
        }),
        _createVNode(_component_Column, {
          field: "issueDateF",
          header: "Issue Date",
          sortable: "",
          sortField: "issueDate",
          style: {"min-width":"140px"}
        })
      ]),
      _: 1
    }, 8, ["value", "scrollHeight", "style"]),
    _createVNode(_component_Dialog, {
      header: `Invoice Status: ${invoice.value?.name} (${invoice.value?.invoiceID})`,
      class: "w-60vw",
      visible: showAnafLog.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showAnafLog).value = $event)),
      modal: ""
    }, {
      default: _withCtx(() => [
        (showAnafLog.value)
          ? (_openBlock(), _createBlock(DataTableAnafLog, {
              key: 0,
              invoice: invoice.value,
              onCloseAnafLog: _cache[0] || (_cache[0] = ($event: any) => ((showAnafLog.value = false), getInvoices()))
            }, null, 8, ["invoice"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ], 64))
}
}

})